<template>
  <v-layout wrap justify-center fill-height>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex xs12 sx12 md12 lg12>
      <!-- :style="
          $vuetify.breakpoint.name == 'xs'
            ? 'height: 815px'
            : $vuetify.breakpoint.name == 'sm'
            ? 'height: 1030px'
            : $vuetify.breakpoint.name == 'md'
            ? 'height: 1370px'
            : $vuetify.breakpoint.name == 'lg'
            ? 'height: 820px'
            : (style = 'height: 100%')
        " -->
      <v-img
        class="white--text align-center"
        style=" height:100vh"
        cover
        src="../../assets/images/Asset 1.png"
      >
        <v-layout wrap justify-center text-center>
          <v-flex md4 align-self-center>
            <v-form>
              <v-layout wrap align-self-center text-center>
                <v-flex xs12 class="head"> Welcome To </v-flex>
                <v-flex xs12 class="font"> School Management System </v-flex>
                <v-flex xs12>
                  <v-img
                    height="250px"
                    contain
                    src="../../assets/images/Asset 2.png"
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 class="font1"> Enter your Mobile number </v-flex>
                <v-flex xs12 class="sub"
                  >You will receive a four digit code to verify.</v-flex
                >

                <v-flex xs12 align-self-center>
                  <v-layout wrap justify-center>
                    <v-flex xs5>
                      <v-form ref="form" @submit.prevent="validateInput">
                        <v-text-field
                          class="centered-input"
                          dark
                          :rules="[rules.required]"
                          color="white"
                          v-model="phoneno"
                          required
                        ></v-text-field>
                      </v-form>
                      <v-layout v-if="msg2" py-4 wrap>
                        <v-flex text-center>
                          <span
                            style="
                              font-family: nunitosansregular;
                              font-size: 14px;
                              color: red;
                            "
                            >{{ msg2 }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex py-12 xs12>
                  <!-- <router-link style='text-decoration:none' :to="{ path: '/loginotp' }  "> <v-btn width="200px"> CONTINUE </v-btn></router-link> -->
                  <v-btn
                    elevation="0"
                    style="background-color: #9eaade; color: white"
                    class="sub"
                    width="280px"
                    @click="validateInput()"
                  >
                    CONTINUE
                  </v-btn>
                </v-flex>
                <v-flex class="sub" pb-12 pt-5 xs12 style="color: #463c86">
                  Exhasuive modules cover all aspects of the administration of
                  the school.
                </v-flex>
                <v-flex xs12> </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-img>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      phoneno: null,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      msg2: null,
      role:["Admin","SuperAdmin"],
      rules: {
        required: (value) => !!value || "Required.",
        min: (value) => value.length <= 10 || "Max 10 characters",
      },
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    validateInput() {
      if (!this.phoneno) {
        this.msg = "Please enter your number";
        this.showsnackbar = true;
        return;
      } else if (this.phoneno.length != 10) {
        this.msg = "Please enter valid number";
        this.showsnackbar = true;
      } else this.login();
    },
    login() {
      this.appLoading = true;
      var data = {};
      data["phone"] = this.phoneno;
      data["role"] = this.role;
      if (this.$refs.form.validate()) {
        axios({
          method: "POST",
          url: "/user/getsms",
          data: data,
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.$emit("stepper", {
                phoneno: this.phoneno,
                response: response.data,
                winStep: 1,
              });
            } else {
              this.msg2 = "Unauthorised access";
            }
          })
          .catch((err) => {
            this.appLoading = false;
            // this.ServerError = true;
            console.log(err);
          });
      }
    },
    //  check() {
    //   this.appLoading = true;
    //     axios({
    //       method: "GET",
    //       url: "/user/check/phone",
    //       params: {
    //       phone:this.phoneno
    //     },
    //     })
    //       .then((response) => {
    //         this.appLoading = false;
    //         if (response.data.status) {
    //          this.msg2="Unauthorised access"
    //          this.showsnackbar=true
    //         } else {
    //           this.msg2 = "Unauthorised access";
    //         }
    //       })
    //       .catch((err) => {
    //         this.appLoading = false;
    //         // this.ServerError = true;
    //         console.log(err);
    //       });
    //   }
  },
};
</script>
<style>
.centered-input input {
  text-align: center;
}
</style>